import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Calendar, User, ArrowLeft } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const BlogDetail = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlog();
  }, [slug]);

  const fetchBlog = async () => {
    try {
      const response = await axios.get(`${API}/blogs/${slug}`);
      setBlog(response.data);
    } catch (error) {
      console.error('Failed to fetch blog:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  }

  if (!blog) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-4">Blog not found</h2>
          <Link to="/blogs" className="text-secondary hover:underline">Back to Blogs</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-background py-24 md:py-32" data-testid="blog-detail-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link to="/blogs" className="inline-flex items-center gap-2 text-secondary hover:underline mb-8" data-testid="back-to-blogs">
          <ArrowLeft className="h-4 w-4" />
          Back to Blogs
        </Link>

        <Card>
          {blog.image_url && (
            <div className="aspect-video overflow-hidden">
              <img src={blog.image_url} alt={blog.title} className="w-full h-full object-cover" />
            </div>
          )}
          <CardContent className="p-8 md:p-12">
            <div className="flex items-center gap-4 text-sm text-muted-foreground mb-6">
              <span className="flex items-center gap-1">
                <Calendar className="h-4 w-4" />
                {new Date(blog.created_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' })}
              </span>
              <span className="flex items-center gap-1">
                <User className="h-4 w-4" />
                {blog.author}
              </span>
              <span className="px-3 py-1 bg-secondary/10 text-secondary rounded-full text-xs">
                {blog.category}
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl font-bold font-playfair mb-6" data-testid="blog-title">
              {blog.title}
            </h1>

            <div className="prose prose-lg max-w-none" data-testid="blog-content">
              <p className="text-lg text-muted-foreground mb-6">{blog.excerpt}</p>
              <div className="whitespace-pre-wrap">{blog.content}</div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default BlogDetail;
